import { createInjectionKey as e } from "../../_utils/vue/create-injection-key.js";
const r = e("n-drawer-body");
export {
  r as drawerBodyInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/drawer/src/interface.js
// module id = 331
// module chunks = 67